import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';

import { GenericContentPage } from './generic-content-page.model';
import { HeadlessCmsService } from '../services/headless-cms.service';

@Injectable()
export class GenericContentPageResolve implements Resolve<GenericContentPage> {

    constructor(private headlessCmsService: HeadlessCmsService) { }

    resolve(route: ActivatedRouteSnapshot) {
        const path = route.pathFromRoot
            .map(function (route) {
                if (route.url[0]) {
                    if (route.url.length > 1) {
                        return route.url[0].path + '/' + route.url[1].path;
                     }
                    else {
                        return route.url[0].path;
                    }
                } else {
                    return ''
                }
            })
            .reduce((fullPath, urlSegment) => {
                return fullPath + urlSegment + '/';
            }, '')
            .replace('//', '/');
        return this.headlessCmsService.getGenericContentByPath(path);
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/resolver/generic.resolve.ts